module.exports = __webpack_public_path__ + "static/media/specter_screenshot.1875a1d7.webp";